import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { SnackbarProvider } from 'notistack';
import { CustomSwitch, CustomTable } from '@/components';
import useStyle from './useStyle';
import useMappedProviders from '@/services/providers/useMappedProviders';

const ProvidersRechargeTable = ({ providers, setPopUpAction, setDefaultValues, getProviders, updateProvider }) => {
  const classes = useStyle();
  const providerRef = React.useRef();
  const mappedProviders = useMappedProviders(providers);

  const openModalEditProvider = (provider) => {
    setDefaultValues({
      id: provider.id,
      beneficiaryId: provider.id,
      reference: provider.name,
      beneficiaryType: provider.rawProvider.beneficiaryType,
      creditorAgent: provider.category,
      beneficiaryUrlImg: provider.rawProvider.beneficiaryUrlImg,
      status: provider.rawDetails.status,
      maxAmount: provider.max,
      minAmount: provider.min,
    });

    setPopUpAction({
      open: true,
      title: 'Editar proveedor',
      data: provider,
    });
  };

  const updateStatus = async (provider) => {
    const body = {
      id: provider.rawProvider.id,
      beneficiaryId: provider.id,
      status: provider.rawDetails.status ? 0 : 1,
    };
    await updateProvider(body);
    await getProviders();
  };

  const createActions = (provider) => (
    <Box display="flex" justifyContent="center">
      <IconButton size="small" onClick={() => openModalEditProvider(provider)}>
        <Tooltip title="Editar">
          <EditIcon className={classes.editIcon} />
        </Tooltip>
      </IconButton>
      <IconButton size="small" disabled style={{ paddingLeft: 10 }}>
        <Tooltip title="Eliminar">
          <DeleteIcon className={classes.editIcon} />
        </Tooltip>
      </IconButton>
    </Box>
  );

  const createStatusSwitch = (provider) => (
    <Tooltip title="Cambiar estado">
      <Box alignSelf="center">
        <CustomSwitch
          checked={provider.rawDetails.status}
          handleChange={() => {}}
          onChange={() => updateStatus(provider)}
          name="active"
        />
      </Box>
    </Tooltip>
  );

  const rows = mappedProviders.map((provider) => ({
    ...provider,
    actions: createActions(provider),
    state: createStatusSwitch(provider),
    active: 1,
  }));

  const columns = [
    { id: 'id', label: 'ID', width: 150 },
    { id: 'name', label: 'Nombre', width: 150 },
    { id: 'icon', label: 'Icono', width: 150 },
    { id: 'category', label: 'Categoría', width: 150 },
    { id: 'min', label: 'Monto mínimo', width: 150 },
    { id: 'max', label: 'Monto máximo', width: 150 },
    { id: 'pay_method', label: 'Método de pago', width: 100 },
    { id: 'vendor', label: 'Agregador', width: 100 },
    { id: 'payment', label: 'Abono', width: 100 },
    { id: 'actions', label: 'Acciones', width: 100 },
    { id: 'state', label: 'Estado', width: 100 },
  ];

  return (
    <SnackbarProvider ref={providerRef}>
      <CustomTable data={rows} columns={columns} />
    </SnackbarProvider>
  );
};

export default ProvidersRechargeTable;